import { render, staticRenderFns } from "./teacherEvaluation.vue?vue&type=template&id=20febdd4"
import script from "./teacherEvaluation.vue?vue&type=script&lang=js"
export * from "./teacherEvaluation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports